import { IndividualRunResponseI } from "@/queries/types";

/**
 * Handles a soft failure of an individual run request.
 * @param response - The response from the individual run request.
 * @returns The status message of the individual run request.
 */
export const handleSoftFailureIndividualRunRequest = (response: IndividualRunResponseI) => {
  if (response?.individual_run?.status === "failed") {
    return response.individual_run.status_message;
  }
};
